import React from 'react'
import PropTypes from 'prop-types'

const TwitterIcon = (props) => {
  const { color = '#ffffff', classes = 'w-20' } = props
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_3180_21466)">
        <circle cx="10" cy="10" r="10" fill="black" />
        <path
          d="M12.8387 5.46973H14.3524L11.0454 9.2495L14.9359 14.3929H11.8896L9.50372 11.2735L6.77368 14.3929H5.25902L8.79627 10.35L5.06409 5.46973H8.18766L10.3443 8.32103L12.8387 5.46973ZM12.3074 13.4869H13.1462L7.73189 6.32818H6.83179L12.3074 13.4869Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3180_21466">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}

TwitterIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(TwitterIcon)
